import React from 'react';
import '../../styles/APSIS.css';

export default function APSISSecurityInnovation() {
  return (
    <div className="apsis-page">
      <div className="apsis-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">SECURITY INNOVATION</span>
            <h1>SECURITY INNOVATION</h1>
            <p>Exploring cutting-edge technologies and solutions in security</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        <section className="apsis-innovation-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>INNOVATION SHOWCASE</h2>
           </div>

           <div className="innovation-grid">
              <div className="innovation-card">
                 <h3>AI-Powered Threat Detection</h3>
                 <p>Advanced machine learning algorithms for real-time security monitoring</p>
                 <div className="innovation-tag">AI & ML</div>
              </div>

              <div className="innovation-card">
                 <h3>IoT Security Solutions</h3>
                 <p>Comprehensive protection for connected devices and smart infrastructure</p>
                 <div className="innovation-tag">IoT</div>
              </div>

              <div className="innovation-card">
                 <h3>Blockchain Security</h3>
                 <p>Decentralized security frameworks for data integrity and authentication</p>
                 <div className="innovation-tag">Blockchain</div>
              </div>

              <div className="innovation-card">
                 <h3>Quantum-Resistant Encryption</h3>
                 <p>Future-proof cryptographic solutions against quantum computing threats</p>
                 <div className="innovation-tag">Cryptography</div>
              </div>
           </div>
        </section>
      </div>
    </div>
  );
}